export function Receipt({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.21973 2.75H15.7803C17.6686 2.75003 18.5403 3.02012 19.0078 3.52051C19.4918 4.03872 19.7453 5.0116 19.7402 7.03809V18.29C19.7402 18.8949 19.6567 19.3292 19.541 19.6143C19.4263 19.897 19.3037 19.9816 19.2451 20.0068C19.1918 20.0297 19.0649 20.059 18.8125 19.9502C18.5523 19.838 18.2091 19.5966 17.8066 19.167C17.2559 18.5771 16.5282 18.2762 15.7871 18.3164C15.0455 18.3568 14.3537 18.7352 13.8701 19.3799L13.8691 19.3809L12.8594 20.7305C12.5753 21.104 12.256 21.2324 11.9951 21.2324C11.7342 21.2324 11.4149 21.1039 11.1309 20.7305L10.1201 19.3809H10.1211C9.16083 18.096 7.44278 17.9667 6.30273 19.0566L6.19043 19.1689L6.18164 19.1787C5.78216 19.6075 5.44081 19.848 5.18164 19.96C4.93018 20.0685 4.80249 20.04 4.74805 20.0166C4.68826 19.9909 4.56536 19.9054 4.4502 19.623C4.33408 19.3382 4.25 18.9042 4.25 18.2998V7.04004C4.25 5.01381 4.50483 4.04049 4.99023 3.52148C5.45908 3.02034 6.33142 2.75003 8.21973 2.75ZM9 9.5C8.17579 9.5 7.5 10.1758 7.5 11C7.5 11.8242 8.17579 12.5 9 12.5H15C15.8242 12.5 16.5 11.8242 16.5 11C16.5 10.1758 15.8242 9.5 15 9.5H9ZM8 5.5C7.17579 5.5 6.5 6.17579 6.5 7C6.5 7.82421 7.17579 8.5 8 8.5H16C16.8242 8.5 17.5 7.82421 17.5 7C17.5 6.17579 16.8242 5.5 16 5.5H8Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </svg>
    </span>
  );
}
